import type { OfflineCommand } from "@/offline/types";

const STORAGE_KEY = "galaxy-offline-queue-v1";

export function loadQueueFromStorage(): OfflineCommand[] {
  if (typeof localStorage === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed as OfflineCommand[];
  } catch {
    return [];
  }
}

export function saveQueueToStorage(queue: OfflineCommand[]): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
}

export function subscribeQueueStorage(onChange: () => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const handler = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) onChange();
  };
  window.addEventListener("storage", handler);
  return () => window.removeEventListener("storage", handler);
}
